export default __webpack_public_path__ + "static/media/2.a86e190d.png";